import {Link} from "gatsby";
import React from "react";
import briefPdf from '../../../assets/pdf/DEHkaiTexni-small.pdf'

const HeaderCollapse = ({isOpen, menuToggle})=>{
    return(
        <>
            <div className="header-menu-collapse-wrapper">
                <div className="header-menu-collapse">
                    <Link to="/" className="xl:ml-6 ml-0 py-1 px-2 font-bold rounded-lg md:text-dark whitespace-nowrap" activeClassName="bg-white text-primary">
                        Ο διαγωνισμός
                    </Link>
                    <Link to="/judges" className="xl:ml-6 py-1 px-2 font-bold rounded-lg md:text-dark whitespace-nowrap" activeClassName="bg-white text-primary">
                        Κριτική επιτροπή
                    </Link>
                    <Link to="/winners" className="xl:ml-6 py-1 px-2 font-bold rounded-lg md:text-dark whitespace-nowrap" activeClassName="bg-white text-primary">
                        Nικητές διαγωνισμού
                    </Link>
                    <div className="xl:ml-auto xl:mr-0 mx-auto">
                        <a href={briefPdf} className="btn-primary" download>
                            Κατέβασε το brief
                        </a>
                    </div>
                </div>
            </div>
            {
                (isOpen) ? <div className="header-menu-back" onClick={()=>{menuToggle()}}/> : null
            }
        </>
    )
}


export default HeaderCollapse;
